module.exports = __webpack_public_path__ + "media/assets/images/loading-064c29dbcf12f7e704f28ba37f2793b8.gif";